import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { searchParamsSchema } from '@/schemas/search';
export const useSearchParamsSchema = () => {
  const $ = _c(12);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    const queryParams = Object.fromEntries(searchParams.entries());
    t0 = searchParamsSchema.safeParse(queryParams);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const parseResult = t0;
  let t1;
  if ($[2] !== parseResult.data || $[3] !== parseResult.success) {
    t1 = parseResult.success ? parseResult.data : {};
    $[2] = parseResult.data;
    $[3] = parseResult.success;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    keyword: t2,
    genre: t3,
    sort: t4,
    device: t5,
    tab: t6,
    type: t7
  } = t1;
  const keyword = t2 === undefined ? null : t2;
  const genre = t3 === undefined ? null : t3;
  const sort = t4 === undefined ? null : t4;
  const device = t5 === undefined ? null : t5;
  const tab = t6 === undefined ? null : t6;
  const type = t7 === undefined ? null : t7;
  let t8;
  if ($[5] !== device || $[6] !== genre || $[7] !== keyword || $[8] !== sort || $[9] !== tab || $[10] !== type) {
    t8 = {
      keyword,
      genre,
      sort,
      device,
      tab,
      type
    };
    $[5] = device;
    $[6] = genre;
    $[7] = keyword;
    $[8] = sort;
    $[9] = tab;
    $[10] = type;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};